import moment from "moment-timezone";

export const getTimezones = () => {
  return moment.tz.names().map((tz, index) => {
    const offset = moment.tz(tz).utcOffset();
    const hours = Math.floor(Math.abs(offset) / 60);
    const minutes = Math.abs(offset) % 60;
    const sign = offset >= 0 ? "+" : "-";

    return {
      id: index + 1,
      value: `${tz} (UTC ${sign}${hours}:${minutes.toString().padStart(2, "0")})`,
    };
  });
};
